import './SmsResult_usage_cost.scss';
import React, { useEffect, useMemo, useState } from 'react';
import fnc from '../mymod/commFunction';
import CustomSpinner from '../comm/CustomSpinner';

const SmsResult_usage_cost = ({ year, month }) => {
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [balanceInfo, setBalanceInfo] = useState({ chargeAmount: 0, latestChargeDate: '' });

    useEffect(() => {
        fncSelect_list();
    }, [year, month]);

    function toNumber(value) {
        const num = Number(String(value ?? '').replace(/,/g, ''));
        return Number.isFinite(num) ? num : 0;
    }

    function formatNumber(value) {
        return toNumber(value).toLocaleString('ko-KR');
    }

    function formatMoney(value) {
        return `${Math.round(toNumber(value)).toLocaleString('ko-KR')}원`;
    }

    function fncSelect_list() {
        if (!year || !month) return;

        setList([]);
        setBalanceInfo({ chargeAmount: 0, latestChargeDate: '' });
        setErrorMessage('');
        setIsLoading(true);

        fnc.sendAxios('/select/sms/usage_cost', { year, month }, (res) => {
            if (res && Array.isArray(res.list)) {
                setList(getRecords(res.list));
                setBalanceInfo({
                    chargeAmount: toNumber(res.balance?.chargeAmount),
                    latestChargeDate: res.balance?.latestChargeDate || ''
                });
            } else if (res && Array.isArray(res)) {
                setList(getRecords(res));
            } else {
                console.log(res, 'kuesbSmsRoutes/select/sms/usage_cost');
                setErrorMessage('사용내역을 조회하지 못했습니다. 해당 월의 로그 테이블이 없을 수 있습니다.');
            }
            setIsLoading(false);
        });
    }

    function getRecords(res) {
        return res.map((item) => ({
            kind: item['구분'] || '',
            ym: item['월'] || '',
            totalCount: toNumber(item['전체개수']),
            failCount: toNumber(item['실패개수']),
            successCount: toNumber(item['성공개수']),
            unitPrice: toNumber(item['단가']),
            amount: toNumber(item['금액'])
        }));
    }

    const totalAmount = useMemo(
        () => list.reduce((sum, item) => sum + toNumber(item.amount), 0),
        [list]
    );
    const vatIncludedAmount = totalAmount * 1.1;
    const chargeAmount = balanceInfo.chargeAmount;
    const balanceAmount = chargeAmount - vatIncludedAmount;
    const now = new Date();
    const currentYm = String(now.getFullYear()) + String(now.getMonth() + 1).padStart(2, '0');
    const selectedYm = String(year || '').replace(/[^0-9]/g, '') + String(month || '').replace(/[^0-9]/g, '').padStart(2, '0');
    const isCurrentMonth = selectedYm === currentYm;

    return (
        <div className="SmsResult_usage_cost">
            <div className="usage-summary">
                <span>{year}년 {month}월 문자 사용내역</span>
                <span>합계 {formatMoney(totalAmount)}</span>
                <span className="vat">부가세 포함 {formatMoney(vatIncludedAmount)}</span>
                {isCurrentMonth && (
                    <span className={balanceAmount < 0 ? 'balance negative' : 'balance'}>
                        충전 잔액: {formatMoney(chargeAmount)} - {formatMoney(vatIncludedAmount)} = {formatMoney(balanceAmount)}
                    </span>
                )}
            </div>

            {errorMessage && <div className="usage-error">{errorMessage}</div>}

            <section className="section-main">
                <table className="table-hong table-main">
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>월</th>
                            <th>전체개수</th>
                            <th>실패개수</th>
                            <th>성공개수</th>
                            <th>단가</th>
                            <th>금액</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item) => (
                            <tr key={item.kind}>
                                <td>{item.kind}</td>
                                <td>{item.ym}</td>
                                <td>{formatNumber(item.totalCount)}</td>
                                <td>{formatNumber(item.failCount)}</td>
                                <td>{formatNumber(item.successCount)}</td>
                                <td>{formatMoney(item.unitPrice)}</td>
                                <td>{formatMoney(item.amount)}</td>
                            </tr>
                        ))}
                        {list.length > 0 && (
                            <>
                                <tr className="total-row">
                                    <td colSpan="6">합계</td>
                                    <td>{formatMoney(totalAmount)}</td>
                                </tr>
                                <tr className="vat-row">
                                    <td colSpan="6">부가세 포함</td>
                                    <td>{formatMoney(vatIncludedAmount)}</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </section>

            {isLoading && <CustomSpinner />}
        </div>
    );
};

export default SmsResult_usage_cost;








